import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import "../assets/css/Zoomstyle.css";

function Zoomproduct({ show, onHide, currentImage }) {
  const [zoomStyle, setZoomStyle] = useState({});
  const [isZoomed, setIsZoomed] = useState(false);

  const updateZoom = (clientX, clientY, container) => {
    const rect = container.getBoundingClientRect();

    const x = clientX - rect.left;
    const y = clientY - rect.top;

    const xPercent = (x / rect.width) * 100;
    const yPercent = (y / rect.height) * 100;

    setZoomStyle({
      transform: "scale(2)",
      transformOrigin: `${xPercent}% ${yPercent}%`,
      transition: "transform 0.08s ease-out",
    });
  };

  // Desktop
  const handleMouseEnter = () => {
    if (window.innerWidth >= 992) {
      setIsZoomed(true);
    }
  };

  const handleMouseMove = (e) => {
    if (!isZoomed) return;
    updateZoom(e.clientX, e.clientY, e.currentTarget);
  };

  const handleMouseLeave = () => {
    setIsZoomed(false);
    setZoomStyle({
      transform: "scale(1)",
      transformOrigin: "center center",
    });
  };

  // Mobile & Tablet
  const handleTouchStart = (e) => {
    setIsZoomed(true);
    const touch = e.touches[0];
    updateZoom(touch.clientX, touch.clientY, e.currentTarget);
  };

  const handleTouchMove = (e) => {
    if (!isZoomed) return;

    const touch = e.touches[0];
    updateZoom(touch.clientX, touch.clientY, e.currentTarget);
  };

  const handleTouchEnd = () => {
    setIsZoomed(false);
    setZoomStyle({
      transform: "scale(1)",
      transformOrigin: "center center",
    });
  };

  return (
    <Modal show={show} onHide={onHide} centered fullscreen>
      <Modal.Header className="p-0 border-0 d-flex justify-content-end">
        <button
          onClick={onHide}
          aria-label="Close"
          style={{
            border: "1px solid #928d8d",
            background: "#fff",
            width: "32px",
            height: "32px",
            borderRadius: "50%",
            color: "#f00",
            cursor: "pointer",
            margin: "10px",
          }}
        >
          <i className="bi bi-x-lg"></i>
        </button>
      </Modal.Header>

      <Modal.Body
        className="d-flex justify-content-center align-items-center"
        style={{ overflow: "hidden" }}
      >
        {currentImage ? (
          <div
            className="zoom-container"
            onMouseEnter={handleMouseEnter}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            <img
              src={currentImage}
              alt="Zoom"
              draggable={false}
              className={`zoom-image ${isZoomed ? "zoomed" : ""}`}
              style={zoomStyle}
            />
          </div>
        ) : (
          <p>No image available</p>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default Zoomproduct;